import { Kmehrcd } from './kmehrcd';
import { Kmehrelement } from './kmehrelement';
import { Kmehrid } from './kmehrid';

export class Kmehrhcparty extends Kmehrelement {
    private allowedElementKeys = ['name', 'firstname', 'familyname'];
    public ids: Kmehrid[] = [];
    public cds: Kmehrcd[] = [];
    public firstname = '';
    public familyname = '';
    public name = '';

    fromJson(json: any) {
        if (!json) {
            return;
        }
        const jsonKeys = Object.keys(json);
        if (jsonKeys && Array.isArray(jsonKeys)) {
            jsonKeys.forEach(key => {
                switch (key) {
                    case 'ids':
                        {
                            const ids = json[key];
                            if (Array.isArray(ids)) {
                                ids.forEach(anId => {
                                    const kmehrid = new Kmehrid();
                                    kmehrid.fromJson(anId);
                                    this.ids.push(kmehrid);
                                });
                            }
                        }
                        break;
                    case 'cds':
                        {
                            const cds = json[key];
                            if (Array.isArray(cds)) {
                                cds.forEach(aCd => {
                                    const kmehrcd = new Kmehrcd();
                                    kmehrcd.fromJson(aCd);
                                    this.cds.push(kmehrcd);
                                });
                            }
                        }
                        break;
                    case 'firstname':
                        {
                            this.firstname = json[key];
                        }
                        break;
                    case 'familyname':
                        {
                            this.familyname = json[key];
                        }
                        break;
                    case 'name':
                        {
                            this.name = json[key];
                        }
                        break;
                }
            });
        }
    }
}
